<template>
  <div class="page-not-found">
    <div class="page-not-found__container">
      <app-icon name="home-wide" />
      <h2 class="page-not-found__title">404</h2>
      <p class="page-not-found__text">Your tour does not exist <br />or was deleted</p>
      <a href="https://homeontour.com" class="button is-primary is-medium">
        Home <app-icon name="arrow-right" />
      </a>
    </div>
  </div>
</template>

<script>
  import Icon from '@/components/icon'

  export default {
    components: {
      appIcon: Icon
    }
  }
</script>

<style lang="scss">
  .page-not-found {
    display: flex;
    width: 100%;
    min-height: 100vh;
    padding: 1.25rem;
    overflow: hidden;
    background-color: var(--color-page-not-found);

    &__container {
      position: relative;
      margin: auto;
      text-align: center;
      color: var(--color-page-not-found-text);

      .icon-home-wide {
        position: absolute;
        top: -5rem;
        left: 50%;
        width: 25rem;
        margin-left: -12.5rem;
        opacity: .1;
      }

    }

    &__title {
      font-size: 5.625rem;
    }

    &__text {
      margin-bottom: 1.875rem;
      font-size: 1.25rem;
      font-weight: 500;
    }

    .button {
      .icon {
        &:first-child:last-child {
          width: 1rem;
          height: 1rem;
          margin-left: 0.625rem;
        }

        path {
          fill: var(--color-page-not-found-button);
        }
      }
    }
  }
</style>
